import { BiBorderRadius } from "react-icons/bi";
import { LuSearch, LuChevronDown } from "@/Components/Icons/Icons";
export default {
  row1 : [
  {
    column: "column1",
    rows: {
      row1: [
        {
          name: "Sr",
          label: "Sr",
          component: "text-field",
        },
        {
          name: "invno",
          label: "Invno",
          component: "text-field",
        },
      ],
      row2: [
        {
          name: "invdate",
          label: "Inv.Date",
          component: "dateselector",
          width:"50%"
          
        },
        {
          name: "cth",
          label: "CTH",
          component: "text-field",
        },
      ],
      row3: [
        {
          name: "Description",
          label: "Description",
          component: "text-field",
        },
      ],
      row4: [
        {
          name: "Quantity",
          label: "Quantity",
          component: "text-field",
        },
        {
          name: "unit",
          label: "Unit",
          component: "text-field",
        },
      ],
    },
  },
]
};
